import * as React from "react";
const SvgPass = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 8, cy: 8, r: 6, stroke: "white", style: {
  stroke: "white",
  strokeOpacity: 1
}, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M11 5.5L7.13043 10.5L5 8.3125", stroke: "white", style: {
  stroke: "white",
  strokeOpacity: 1
}, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgPass;
